import { render, staticRenderFns } from "./recordDialog.vue?vue&type=template&id=4bd238e9&scoped=true"
import script from "./recordDialog.vue?vue&type=script&lang=js"
export * from "./recordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd238e9",
  null
  
)

export default component.exports